import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { LayoutDashboard, X } from 'lucide-react';

import { WizardOptionCard } from './WizardOptionCard';
import type { QuickstartAnswers } from './types';

interface StepPortalProps {
    answers: QuickstartAnswers;
    onChange: (next: Partial<QuickstartAnswers>) => void;
}

export function StepPortal({ answers, onChange }: StepPortalProps) {
    const { t } = useTranslation('common');
    const select = (value: boolean) => onChange({ wantsPortal: value });

    // Preselect the first option ("Yes") on mount.
    React.useEffect(() => {
        if (answers.wantsPortal === null) {
            onChange({ wantsPortal: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="flex flex-col gap-4">
            <div>
                <h3 className="text-lg font-semibold">
                    {t('funnelQuickstart.portal.title')}
                </h3>
                <p className="text-muted-foreground text-sm">
                    {t('funnelQuickstart.portal.subtitle')}
                </p>
            </div>

            <div className="flex flex-col gap-3">
                <WizardOptionCard
                    title={t('funnelQuickstart.portal.yes.title')}
                    description={t('funnelQuickstart.portal.yes.description')}
                    icon={<LayoutDashboard className="h-5 w-5" />}
                    selected={answers.wantsPortal === true}
                    onSelect={() => select(true)}
                />
                <WizardOptionCard
                    title={t('funnelQuickstart.portal.no.title')}
                    description={t('funnelQuickstart.portal.no.description')}
                    icon={<X className="h-5 w-5" />}
                    selected={answers.wantsPortal === false}
                    onSelect={() => select(false)}
                />
            </div>
        </div>
    );
}
